import { createHashRouter, RouterProvider, useParams } from 'react-router-dom';
import { useBusiness } from 'hooks/useBusiness';
import { useLocalization } from 'hooks/useLocalization';

import { Alert, Box, CircularProgress } from '@mui/material';

import ActivityShop from 'pages/ActivityShop';
import Checkout from 'pages/Checkout';
import Booking from 'pages/Booking';
import Pay from 'pages/Pay';
import AwaitingPayment from 'pages/AwaitingPayment';
import PaddingWrap from 'components/shared/PaddingWrap';
import CenteredContent from 'components/shared/CenteredContent';
import { ActivityShopUIProvider } from 'contexts/ActivityShopUIContext';
import TitleHandler from 'components/general/TitleHandler'; // Import your TitleHandler component

interface TourTaskBookingProps {
	page: string;
}

function TourTaskBooking({ page }: TourTaskBookingProps) {
	const { getStr } = useLocalization();
	const { isBusinessLoaded, businessConfigError } = useBusiness();

	if (!isBusinessLoaded) {
		return (
			<>
				<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px' }}>
					<CircularProgress />
				</Box>
			</>
		);
	} else {
		let mainPageComponent;

		switch (page) {
			case 'activities':
				mainPageComponent = <ActivityShop />;
				break;
			default:
				mainPageComponent = <CenteredContent><PaddingWrap><Alert severity="error">{getStr('Invalid_page') + (page !== '' ? ` "${page}"` : '')}</Alert></PaddingWrap></CenteredContent>
				break;
		}

		const router = createHashRouter([
			{
				path: '/',
				element: <ActivityShopUIProvider>{mainPageComponent}</ActivityShopUIProvider>
			},
			{
				path: '/' + getStr('PUBLIC_APP_URL_info') + '/:activityId/:activitySlug',
				element: <ActivityShopUIProvider>{mainPageComponent}</ActivityShopUIProvider>
			},
			{
				path: '/' + getStr('PUBLIC_APP_URL_checkout'),
				element: <ActivityShopUIProvider><Checkout /></ActivityShopUIProvider>
			},
			{
				path: '/' + getStr('PUBLIC_APP_URL_booking') + '/:bookingNumber/:bookingToken',
				element: <TitleHandler title={getStr('Booking')}><CenteredContent><PaddingWrap><Booking /></PaddingWrap></CenteredContent></TitleHandler>
			},
			{
				path: '/' + getStr('PUBLIC_APP_URL_pay') + '/:bookingNumber/:bookingToken/:gatewayCode/:redirectId',
				element: <TitleHandler title={getStr('Confirming_payment')}><CenteredContent><PaddingWrap><Pay /></PaddingWrap></CenteredContent></TitleHandler>
			},
			{
				path: '/' + getStr('PUBLIC_APP_URL_awaiting-payment') + '/:bookingNumber/:bookingToken/:gatewayCode/:redirectId',
				element: <TitleHandler title={getStr('Awaiting_payment')}><CenteredContent><PaddingWrap><AwaitingPayment /></PaddingWrap></CenteredContent></TitleHandler>
			}
		]);

		return <RouterProvider router={router}/>;
	}
}

export default TourTaskBooking;